<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!respostas.length && !loading" align="center" class="headline">
      Nenhuma resposta encontrada!
    </div>
    <v-expansion-panels class="rounded-card" multiple focusable
      v-if="respostas && respostas.length && !loading">
      <v-expansion-panel
        active-class="rounded-card"
        v-for="resposta in respostas"
        :key="resposta.id"
      >
        <v-expansion-panel-header>
          <px-cotacao-resposta-view-fornecedor-header :resposta="resposta"
                                                      :cotacao="cotacao"
                                                      :casa-decimal="casaDecimal"
                                                      :is-modal-view="isModalView"
                                                      @update="onUpdate"/>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <px-cotacao-resposta-produtos :resposta="resposta"/>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { CasaDecimalUtils } from 'px-components';
import RespostaService from '@/modules/cotacao/resposta/resposta-service';
import CotacaoRespostaProdutos from './CotacaoRespostaProdutos.vue';
import CotacaoRespostaViewFornecedorHeader from './CotacaoRespostaViewFornecedorHeader.vue';

export default {
  props: {
    searchText: String,
    selectedSort: Object,
    cotacaoId: {
      type: [String, Number],
      required: true,
    },
    cotacao: {
      type: Object,
    },
    isModalView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      respostas: [],
      loading: false,
      panel: null,
    };
  },
  computed: {
    casaDecimal() {
      const mappedProdutos = this.cotacao.produtos.map(produto => produto.produto);
      return CasaDecimalUtils.getCasaDecimal(mappedProdutos);
    },
  },
  methods: {
    getRespostas() {
      this.loading = true;
      const query = this.buildQuery();
      RespostaService.getRespostas(this.cotacaoId, {
        query,
      })
        .then((response) => {
          this.respostas = response.data;
          this.buildFornecedores();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildFornecedores() {
      this.respostas = this.respostas.map(resposta => this.mapResposta(resposta));
    },
    mapResposta(respostaToMap) {
      const resposta = { ...respostaToMap };
      resposta.fornecedor = this.getFornecedorWithCodigoInterno(resposta.fornecedor);
      return resposta;
    },
    getFornecedorWithCodigoInterno(fornecedor) {
      const detalheFornecedor = this.cotacao.detalhesFornecedores
        .find(detalhe => detalhe.fornecedor.id === fornecedor.id);
      if (!detalheFornecedor) {
        return {
          ...fornecedor,
        };
      }
      return {
        ...fornecedor,
        codigoInterno: detalheFornecedor.codigoInterno,
      };
    },
    buildQuery() {
      return `${this.buildFilter()} ${this.buildSort()}`.trim();
    },
    buildFilter() {
      if (!this.searchText) {
        return '';
      }
      return `fornecedor.nome like "%${this.searchText.toLowerCase()}%"`;
    },
    buildSort() {
      if (!this.selectedSort) {
        return '';
      }
      return `order by favorito desc, ${this.selectedSort.value}`;
    },
    onUpdate() {
      this.getRespostas();
    },
  },
  watch: {
    searchText(newText, oldText) {
      if (newText === oldText) {
        return;
      }
      this.getRespostas();
    },
    selectedSort(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getRespostas();
    },
  },
  created() {
    this.getRespostas();
  },
  components: {
    pxCotacaoRespostaProdutos: CotacaoRespostaProdutos,
    pxCotacaoRespostaViewFornecedorHeader: CotacaoRespostaViewFornecedorHeader,
  },
};
</script>
